import { HookFormProvider, InputDatePicker, InputImageUpload, InputSelect, InputTextEditor, InputTextField } from "src/app/components/HookForm";
import { SalesPromoFormProps } from "./SalesPromoForm.types";
import { Alert, Button, Checkbox, ControlLabel, DialogRef, Divider, Stack, Typography } from "src/app/components";
import InputSelectMall from "src/app/components/HookForm/InputSelect/InputSelect.mall";
import { useEffect, useRef } from "react";
import { usePermissions } from "src/app/hooks/permissions-hook";
import { useSalesPromoForm1 } from "./SalesPromoForm1.hook";
import { DateObject } from "react-multi-date-picker";
import InputRadioGroupSimple from "src/app/components/HookForm/InputRadioGroup/InputRadioGroupSimple.page";
import { SalesPromoModel } from "../../../models/SalesPromo.model";
import { Refs } from "src/app/utils/refs-utils";
import { getErrorMessage } from "src/app/utils/api-utils";
import { Controller } from "react-hook-form";
import { TEXT_ON_POPUP_MAX_LENGTH, validateTextOnPopup } from "./SalesPromoForm1.utils";



export function SalesPromoForm1(props: Readonly<SalesPromoFormProps>) {
    const alertSaveAsDraftRef = useRef<DialogRef>(null);
    const permission = usePermissions()
    const state = useSalesPromoForm1(props.id)
    const isDirectCashbackPoint = state.form.watch('is_direct_cashback_point')
    const cashbackType = state.form.watch('cashback_type')
    const cashbackTypeSelect = state.form.watch('cashback_type_select')
    const isMissionCollectStamp = state.form.watch('is_mission_collect_stamp')
    const is_unlimited_claim_per_day = state.form.watch('is_unlimited_claim_per_day')
    const is_unlimited_claim_per_period = state.form.watch('is_unlimited_claim_per_period')
    const is_unlimited_customer_per_day = state.form.watch('is_unlimited_customer_per_day')
    const is_unlimited_daily_quota_earned = state.form.watch('is_unlimited_daily_quota_earned')
    const quotaType = state.form.watch('quota_type')
    const isEdit = !!props.id && (['PENDING', 'ACTIVE'].includes(state.salesPromoDetailStatus ?? ''));

    useEffect(() => {
        if (state.isFormFilled) {
            props.doPreventExit && props.doPreventExit(!!state.isFormFilled)
        }
    }, [state.isFormFilled]);

    useEffect(() => {
        if (cashbackType && !cashbackTypeSelect) {
            const selectedData = state.masterCampaignType.find(item => item.value === cashbackType);
            state.form.setValue('cashback_type_select', selectedData);
        }
    }, [cashbackType]);

    const saveAsDraft = (key: string) => {
        alertSaveAsDraftRef.current?.hide()
        const formData = state.form.getValues()
        const payload: SalesPromoModel = {
            ...formData,
            directory_ids: formData.directories?.map(_ => _?.id),
            category: "SALES_PROMO",
            is_draft: true,
            image: formData.image?.split('base64,', 2)[1],
            stamp_icon: formData.stamp_icon?.split('base64,', 2)[1],
            stamp_success: formData.stamp_success?.split('base64,', 2)[1],
            cashback_type: formData.cashback_type_select?.value ?? '',
            direct_gift_determination: formData.direct_gift_determination ?? undefined
        }
        if (isEdit) {
            payload.id = props.id
        }
        delete payload.campaign_type
        delete payload.directories
        delete payload.cashback_type_select
        hitPostAPI(payload, key)
    }

    const submitButtonClick = state.form.handleSubmit(async ({
        directories,
        image,
        cashback_type_select,
        direct_gift_determination,
        ...formData
    }) => {
        // Create the final payload, excluding bank_rewards and bank_reward_codes_file
        const payload: SalesPromoModel = {
            ...formData,
            directory_ids: directories?.map(_ => _?.id),
            image: image?.split('base64,', 2)[1],
            stamp_icon: formData.stamp_icon?.split('base64,', 2)[1],
            stamp_success: formData.stamp_success?.split('base64,', 2)[1],
            category: "SALES_PROMO",
            cashback_type: cashback_type_select?.value ?? '',
            direct_gift_determination: direct_gift_determination ?? undefined
        }
        if (isEdit) {
            payload.id = props.id
            delete payload.thumbnail_image
        }
        hitPostAPI(payload, 'SUBMIT')
    })

    const hitPostAPI = async (payload: any, key: string) => {
        try {
            const result = await state.saveSalesPromoGeneral.mutateAsync(payload)
            const response_output = result.data.response_output
            const contentDetail = response_output?.detail
            if (key === 'SUBMIT') {
                props.save && props.save(contentDetail)
            } else {
                props.saveDraft && props.saveDraft(key, contentDetail)
            }
        } catch (error: any) {
            const fieldErrors = error?.response?.data?.response_output?.errors;
            if (Array.isArray(fieldErrors)) {
                fieldErrors.forEach((err: any) => {
                    if (err.field) {
                        state.form.setError(err.field, {
                            type: 'serverError',
                            message: err.message?.en || err.message,
                        });
                    }
                });
            }
            if (error?.response?.data?.response_schema?.response_code === 'PAKUWON-400')
                Refs.pageToast.show({
                    severity: 'danger',
                    message: `${getErrorMessage(error, true)?.en}`
                });
        }
    }
    const saveAndExit = () => {
        const { status } = state.salesPromoDetail.data;
        const isPendingOrActive = status === 'PENDING' || status === 'ACTIVE';

        props.doPreventExit?.(false);
        isPendingOrActive ? saveWithTrigger() : saveAsDraft('STAY');
    };

    const saveWithTrigger = state.form.handleSubmit(() => saveAsDraft('STAY'));

    return (
        <>
            <HookFormProvider
                enables={state.enabledFields()}
                query={state.salesPromoDetail}
                mutation={state.saveSalesPromoGeneral}
                form={state.form}
            >
                <Stack className="p-6">
                    <ControlLabel label="Campaign Name">
                        <InputTextField
                            placeholder="Enter campaign name"
                            rule={{ required: true }}
                            name="name"
                            maxLength={99}
                        />
                    </ControlLabel>

                    <ControlLabel label="Mall">
                        <InputSelectMall placeholder="Type to add" isMulti={true} form={state.form} rule={{ required: true }} />
                    </ControlLabel>

                    <ControlLabel label="Periode" required={true}>
                        <Stack direction="row" items="center">
                            <InputDatePicker
                                placeholder="Select start date"
                                minDate={state.minPeriod.minStartDate}
                                rule={{ required: true }}
                                name="start_date"
                                form={state.form}
                            />
                            <Divider className="w-[50px] border-t-2" color="primary" />
                            <InputDatePicker
                                placeholder="Select end date"
                                minDate={state.minPeriod.minEndDate}
                                rule={{ required: true }}
                                name="end_date"
                                form={state.form}
                                maxDate={new DateObject().add(5, 'year')}
                            />
                        </Stack>
                    </ControlLabel>

                    <ControlLabel label="Direct Cashback Point" required>
                        <InputRadioGroupSimple
                            name="is_direct_cashback_point"
                            options={[
                                { label: 'Yes', value: true },
                                { label: 'No', value: false }
                            ]}
                            required
                            onChange={(val) => {
                                if (val === true) {
                                    state.form.setValue('quota_type', 'CUSTOMER');
                                } else {
                                    state.form.setValue('quota_type', undefined);
                                }
                                state.form.setValue('earn_point', undefined);
                                state.form.setValue('point_multiplication', undefined);
                                state.form.setValue('max_earn_point', undefined);
                                state.form.setValue('direct_gift_determination', undefined);
                                state.form.setValue('is_mission_collect_stamp', undefined);
                                state.form.setValue('prize_quantity_per_round', undefined);
                                state.form.setValue('total_stamp_per_round', undefined);
                                state.form.setValue('max_round_per_customer', undefined);
                                state.form.setValue('stamp_name', undefined);
                                state.form.setValue('stamp_icon', undefined);
                                state.form.setValue('stamp_success', undefined);
                                state.form.setValue('max_daily_quota_earned', undefined);
                                state.form.setValue('max_customer_per_day', undefined);
                                state.form.clearErrors('quota_type');
                            }}
                        />
                    </ControlLabel>

                    {isDirectCashbackPoint && (
                        <Stack className="pl-6">
                            <ControlLabel label="Cashback Type">
                                <InputSelect
                                    placeholder="Select cashback type"
                                    isMulti={false}
                                    options={state.masterCampaignType}
                                    rule={{ required: true }}
                                    form={state.form}
                                    name="cashback_type_select"
                                    onChangeValue={(value: any) => {
                                        state.form.setValue('cashback_type', value?.value);
                                    }}
                                    selectOption={(option) => ({
                                        label: option.label,
                                        value: option.value,
                                    })}
                                />
                            </ControlLabel>

                            {cashbackType === 'EXTRA_POINT' && (
                                <ControlLabel label="Earn Point" required>
                                    <InputTextField
                                        placeholder="Enter earn point"
                                        name="earn_point"
                                        type="number"
                                        rule={{
                                            required: true,
                                            min: { value: 1, message: 'Minimum earn poin is 1' },
                                            max: { value: 999999999, message: 'Maximum earn poin is 999.999.999' },
                                        }}
                                    />
                                </ControlLabel>
                            )}

                            {cashbackType === 'MULTIPLICATION_POINT' && (
                                <>
                                    <ControlLabel label="Multiplication Number" required>
                                        <InputTextField
                                            placeholder="Enter multiplication number"
                                            name="point_multiplication"
                                            type="number"
                                            rule={{
                                                required: true,
                                                min: { value: 1, message: 'Minimum multiplication poin is 1' },
                                                max: { value: 999999999, message: 'Maximum multiplication poin is 999.999.999' },
                                            }}
                                        />
                                    </ControlLabel>
                                    <ControlLabel label="Max. Earned Point" required>
                                        <InputTextField
                                            placeholder="Enter max earn point"
                                            name="max_earn_point"
                                            type="number"
                                            rule={{
                                                required: true,
                                                min: { value: 1, message: 'Minimum max earn poin is 1' },
                                                max: { value: 999999999, message: 'Maximum max earn poin is 999.999.999' },
                                            }}
                                        />
                                    </ControlLabel>
                                </>
                            )}
                        </Stack>
                    )}

                    {!isDirectCashbackPoint && (
                        <>
                            <ControlLabel label="Direct Gift Determination" required>
                                <InputRadioGroupSimple
                                    name="direct_gift_determination"
                                    options={[
                                        { label: 'Random by system', value: 'RANDOM', disabled: state.form.watch('is_mission_collect_stamp') },
                                        { label: 'Customer Service', value: 'CUSTOMER_SERVICE' }
                                    ]}
                                    required
                                />
                            </ControlLabel>
                            <ControlLabel label="Mission Collect Stamp" required>
                                <InputRadioGroupSimple
                                    name="is_mission_collect_stamp"
                                    options={[
                                        { label: 'Yes', value: true },
                                        { label: 'No', value: false }
                                    ]}
                                    onChange={(_) => {
                                        if (_) {
                                            state.form.setValue('direct_gift_determination', 'CUSTOMER_SERVICE')
                                        }
                                        state.form.setValue('prize_quantity_per_round', undefined);
                                        state.form.setValue('total_stamp_per_round', undefined);
                                        state.form.setValue('max_round_per_customer', undefined);
                                        state.form.setValue('stamp_name', undefined);
                                        state.form.setValue('stamp_icon', undefined);
                                        state.form.setValue('stamp_success', undefined);
                                    }}
                                    required
                                />
                            </ControlLabel>

                            {isMissionCollectStamp && (
                                <Stack className="pl-6">
                                    <ControlLabel label="Prize Qty/Round" required>
                                        <InputTextField
                                            placeholder="Enter prize qty per round"
                                            name="prize_quantity_per_round"
                                            type="number"
                                            rule={{
                                                required: true,
                                                min: { value: 1, message: 'Minimum prize qty per round is 1' },
                                                max: { value: 999999999, message: 'Maximum prize qty per round is 999.999.999' },
                                            }}
                                        />
                                    </ControlLabel>
                                    <ControlLabel label="No. of Stamps / Round" required>
                                        <InputTextField
                                            placeholder="Enter number of stamps per round"
                                            name="total_stamp_per_round"
                                            type="number"
                                            rule={{
                                                required: true,
                                                min: { value: 1, message: 'Minimum number of stamps per round is 1' },
                                                max: { value: 999999999, message: 'Maximum number of stamps per round is 999.999.999' },
                                            }}
                                        />
                                    </ControlLabel>
                                    <ControlLabel label="Max. Stamp/Day" required>
                                        <InputTextField
                                            placeholder="Enter number of max. stamp/day"
                                            name="max_stamp_per_day"
                                            type="number"
                                            rule={{
                                                required: true,
                                                min: { value: 1, message: 'Minimum number of max. stamp/day is 1' },
                                                max: { value: 999999999, message: 'Maximum number of max. stamp/day is 999.999.999' },
                                            }}
                                        />
                                    </ControlLabel>
                                    <ControlLabel label="Max. Round / Customer" required>
                                        <InputTextField
                                            placeholder="Enter maximum claim per day per customer"
                                            name="max_round_per_customer"
                                            type="number"
                                            rule={{
                                                required: true,
                                                min: { value: 1, message: 'Minimum maximum claim per day per customer is 1' },
                                                max: { value: 999999999, message: 'Maximum maximum claim per day per customer is 999.999.999' },
                                            }}
                                        />
                                    </ControlLabel>
                                    <ControlLabel label="Stamp name in PG Card App">
                                        <InputTextField
                                            placeholder="Enter Stamp name in PG Card App"
                                            rule={{ required: true }}
                                            name="stamp_name"
                                            maxLength={99}
                                        />
                                    </ControlLabel>
                                    <ControlLabel label="Stamps Icon Reguler" required={true}>
                                        <div className="grid grid-cols-3 gap-8">
                                            <InputImageUpload
                                                placeholder="Upload Photo (JPG/PNG)"
                                                maxSize={Math.pow(1024, 2) * 5}
                                                accept={['.jpg', '.jpeg', '.png']}
                                                rule={{ required: true }}
                                                form={state.form}
                                                name="stamp_icon"
                                                ratio="square"
                                            />
                                            <div className="flex flex-col justify-center col-span-2">
                                                <ul className="text-xs text-gray-500 list-disc list-inside dark:text-gray-400">
                                                    <li className="mb-4">
                                                        Size: Max size of file is <strong>5 MB</strong>.
                                                    </li>
                                                    <li className="mb-4">
                                                        Photo ratio is <strong>1:1</strong>
                                                    </li>
                                                    <li>
                                                        File format: only allow <strong>.jpg / .png</strong>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </ControlLabel>
                                    <ControlLabel label="Stamps Icon Success" required={true}>
                                        <div className="grid grid-cols-3 gap-8">
                                            <InputImageUpload
                                                placeholder="Upload Photo (JPG/PNG)"
                                                maxSize={Math.pow(1024, 2) * 5}
                                                accept={['.jpg', '.jpeg', '.png']}
                                                rule={{ required: true }}
                                                form={state.form}
                                                name="stamp_success"
                                                ratio="square"
                                            />
                                            <div className="flex flex-col justify-center col-span-2">
                                                <ul className="text-xs text-gray-500 list-disc list-inside dark:text-gray-400">
                                                    <li className="mb-4">
                                                        Size: Max size of file is <strong>5 MB</strong>.
                                                    </li>
                                                    <li className="mb-4">
                                                        Photo ratio is <strong>1:1</strong>
                                                    </li>
                                                    <li>
                                                        File format: only allow <strong>.jpg / .png</strong>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </ControlLabel>
                                </Stack>
                            )}
                        </>
                    )}

                    <ControlLabel label="Campaign Image" required={true}>
                        <div className="grid grid-cols-2 gap-8">
                            <InputImageUpload
                                placeholder="Upload Photo (JPG/PNG)"
                                maxSize={Math.pow(1024, 2) * 5}
                                accept={['.jpg', '.jpeg', '.png']}
                                rule={{ required: true }}
                                form={state.form}
                                name="image"
                            />
                            <div className="flex flex-col justify-center">
                                <ul className="text-xs text-gray-500 list-disc list-inside dark:text-gray-400">
                                    <li className="mb-4">
                                        Size: Max size of file is <strong>5 MB</strong>.
                                    </li>
                                    <li className="mb-4">
                                        Photo ratio is <strong>16:9</strong>
                                    </li>
                                    <li>
                                        File format: only allow <strong>.jpg / .png</strong>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </ControlLabel>
                    <ControlLabel label="Text on Pop up (EN)" required={true}>
                        <div>
                            <InputTextEditor
                                height={150}
                                form={state.form}
                                name="text_on_popup_eng"
                                placeholder="Enter text on pop up (EN)"
                                maxLength={TEXT_ON_POPUP_MAX_LENGTH}
                                rule={{
                                    required: true,
                                    validate: validateTextOnPopup,
                                }}
                            />
                        </div>
                    </ControlLabel>
                    <ControlLabel label="Text on Pop up (ID)" required={true}>
                        <div>
                            <InputTextEditor
                                height={150}
                                form={state.form}
                                name="text_on_popup_idn"
                                placeholder="Enter text on pop up (ID)"
                                maxLength={TEXT_ON_POPUP_MAX_LENGTH}
                                rule={{
                                    required: true,
                                    validate: validateTextOnPopup,
                                }}
                            />
                        </div>
                    </ControlLabel>
                    <ControlLabel label="Terms & Conditions (EN)">
                        <div>
                            <InputTextEditor height={150} form={state.form} name="tnc_eng" placeholder="Enter terms & condition (EN)" />
                        </div>
                    </ControlLabel>
                    <ControlLabel label="Terms & Conditions (ID)">
                        <div>
                            <InputTextEditor height={150} form={state.form} name="tnc_idn" placeholder="Enter terms & condition (ID)" />
                        </div>
                    </ControlLabel>




                    <span className="font-semibold">Customer Rules</span>

                    <ControlLabel label="Max. Claim/Day/Customer" required={true}>
                        <Stack direction="row" >
                            <div className="w-full">
                                <InputTextField
                                    placeholder="Enter maximum claim per day per customer"
                                    name="max_claim_per_day"
                                    type="number"
                                    disabled={is_unlimited_claim_per_day}
                                    rule={{
                                        required: true,
                                        min: {
                                            value: is_unlimited_claim_per_day ? 0 : 1,
                                            message: 'Minimum maximum claim per day per customer is 1',
                                        },
                                        max: {
                                            value: 999999999,
                                            message: 'Maximum maximum claim per day per customer is 999.999.999',
                                        },
                                    }}
                                />
                            </div>
                            <div className="min-w-[100px] h-[42px] content-center">
                                <Controller
                                    name="is_unlimited_claim_per_day"
                                    control={state.form.control}
                                    render={({ field }) => (
                                        <Checkbox
                                            label="Unlimited"
                                            checked={field.value}
                                            onChange={(e) => {
                                                field.onChange(e.target.checked);
                                                state.form.setValue('max_claim_per_day', 0);
                                                state.form.clearErrors('max_claim_per_day');
                                            }}
                                        />
                                    )}
                                />
                            </div>
                        </Stack>
                    </ControlLabel>
                    <ControlLabel label="Max. Claim/Period/Customer" required={true}>
                        <Stack direction="row" >
                            <div className="w-full">
                                <InputTextField
                                    placeholder="Enter maximum claim per period per customer"
                                    name="max_claim_per_period"
                                    disabled={is_unlimited_claim_per_period}
                                    type="number"
                                    rule={{
                                        required: true,
                                        min: {
                                            value: is_unlimited_claim_per_period ? 0 : 1,
                                            message: 'Minimum maximum claim per period per customer is 1',
                                        },
                                        max: {
                                            value: 999999999,
                                            message: 'Maximum maximum claim per period per customer is 999.999.999',
                                        },
                                    }}
                                />
                            </div>
                            <div className="min-w-[100px] h-[42px] content-center">
                                <Controller
                                    name="is_unlimited_claim_per_period"
                                    control={state.form.control}
                                    render={({ field }) => (
                                        <Checkbox
                                            label="Unlimited"
                                            checked={field.value}
                                            disabled={state.salesPromoDetailStatus === 'ACTIVE'}
                                            onChange={(e) => {
                                                field.onChange(e.target.checked);
                                                state.form.setValue('max_claim_per_period', 0);
                                                state.form.clearErrors('max_claim_per_period');
                                            }}
                                        />
                                    )}
                                />
                            </div>
                        </Stack>

                    </ControlLabel>

                    <span className="font-semibold">Quota Rules</span>
                    <ControlLabel label="Quota Type" required>
                        <InputRadioGroupSimple
                            name="quota_type"
                            options={[
                                { label: 'Prizes', value: 'PRIZE' },
                                { label: 'Customer', value: 'CUSTOMER' }
                            ]}
                            required
                            onChange={() => {
                                state.form.setValue('max_daily_quota_earned', undefined);
                                state.form.setValue('max_customer_per_day', undefined);
                                state.form.setValue('is_unlimited_daily_quota_earned', false);
                                state.form.setValue('is_unlimited_customer_per_day', false);
                            }}
                            disabled={isDirectCashbackPoint?.toString() === 'true' ? true : undefined}
                        />
                    </ControlLabel>
                    <ControlLabel label="Total Quota" required={true}>
                        <InputTextField
                            placeholder="Enter total quota"
                            name="total_quota"
                            type="number"
                            rule={{
                                required: true,
                                min: {
                                    value: 1,
                                    message: 'Minimum total quota is 1',
                                },
                                max: {
                                    value: 999999999,
                                    message: 'Maximum total quota is 999.999.999',
                                },
                            }}
                        />
                    </ControlLabel>
                    {quotaType?.toString() === 'PRIZE' && (
                        <ControlLabel label="Max. Daily Quota Earned" required={true}>
                            <Stack direction="row" >
                                <div className="w-full">
                                    <InputTextField
                                        placeholder="Enter maximum daily quota earned"
                                        name="max_daily_quota_earned"
                                        disabled={is_unlimited_daily_quota_earned}
                                        type="number"
                                        rule={{
                                            required: true,
                                            min: {
                                                value: is_unlimited_daily_quota_earned ? 0 : 1,
                                                message: 'Minimum maximum daily quota earned is 1',
                                            },
                                            max: {
                                                value: 999999999,
                                                message: 'Maximum maximum daily quota earned is 999.999.999',
                                            },
                                        }}
                                    />
                                </div>
                                <div className="min-w-[100px] h-[42px] content-center">
                                    <Controller
                                        name="is_unlimited_daily_quota_earned"
                                        control={state.form.control}
                                        render={({ field }) => (
                                            <Checkbox
                                                label="Unlimited"
                                                checked={field.value}
                                                onChange={(e) => {
                                                    field.onChange(e.target.checked);
                                                    state.form.setValue('max_daily_quota_earned', 0);
                                                    state.form.clearErrors('max_daily_quota_earned');
                                                }}
                                            />
                                        )}
                                    />
                                </div>
                            </Stack>
                        </ControlLabel>
                    )}
                    {quotaType?.toString() === 'CUSTOMER' && (
                        <ControlLabel label="Max. Claim Customer/Day" required={true}>
                            <Stack direction="row" >
                                <div className="w-full">
                                    <InputTextField
                                        placeholder="Enter maximum claim customer per day"
                                        name="max_customer_per_day"
                                        disabled={is_unlimited_customer_per_day}
                                        type="number"
                                        rule={{
                                            required: true,
                                            min: {
                                                value: is_unlimited_customer_per_day ? 0 : 1,
                                                message: 'Minimum maximum claim customer per day is 1',
                                            },
                                            max: {
                                                value: 999999999,
                                                message: 'Maximum maximum claim customer per day is 999.999.999',
                                            },
                                        }}
                                    />
                                </div>
                                <div className="min-w-[100px] h-[42px] content-center">
                                    <Controller
                                        name="is_unlimited_customer_per_day"
                                        control={state.form.control}
                                        render={({ field }) => (
                                            <Checkbox
                                                label="Unlimited"
                                                checked={field.value}
                                                onChange={(e) => {
                                                    field.onChange(e.target.checked);
                                                    state.form.setValue('max_customer_per_day', 0);
                                                    state.form.clearErrors('max_customer_per_day');
                                                }}
                                            />
                                        )}
                                    />
                                </div>
                            </Stack>
                        </ControlLabel>
                    )}

                </Stack>
                <Stack
                    className={'px-8 py-6 border-t border-neutral-200'}
                    direction="row"
                    gap={4}
                >
                    {permission.setVisibleByAccess(
                        ['manage_campaign_sales_promo.create', 'manage_campaign_sales_promo.update'],
                        <Button disabled={!state.isFormFilled} variant='outlined' loading={state.saveSalesPromoGeneral.isLoading} onClick={() => { isEdit ? saveAndExit() : alertSaveAsDraftRef.current?.show() }}>{'Save' + (!isEdit ? ' as Draft' : '')}</Button>,
                    )}

                    <Stack
                        direction="row"
                        justify='end'
                        gap={4}
                    >
                        {permission.setVisibleByAccess(
                            ['manage_campaign_sales_promo.create', 'manage_campaign_sales_promo.update'],
                            <Button disabled={!state.isFormFilled} loading={state.saveSalesPromoGeneral.isLoading} onClick={() => submitButtonClick()}>Next</Button>,
                        )}

                    </Stack>
                </Stack>
            </HookFormProvider>
            <Alert
                cancelText="Go to List"
                submitText="Stay on page"
                onCancel={() => saveAsDraft('BACK')}
                onSubmit={() => saveAsDraft('STAY')}
                title="Save as Draft?"
                ref={alertSaveAsDraftRef}
                closeOnBackdropClicked={false}
            >
                <Typography>
                    Your progress will be saved as a draft. You can continue editing later.
                    <br />Would you like to stay on this page or return to the list?
                </Typography>
            </Alert>
        </>
    )
}
